import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col text-left text-brown" }
const _hoisted_2 = { class: "font-semibold text-xl leading-[24px] mb-6" }
const _hoisted_3 = { class: "text-base font-normal leading-[20px] mb-6" }
const _hoisted_4 = { class: "font-medium text-base leading-100p mb-4" }
const _hoisted_5 = { class: "list-disc pl-7 text-left text-brown text-base leading-[20px] mb-4" }
const _hoisted_6 = { class: "font-bold" }

import { useI18n } from "vue-i18n";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PredictionInstruction',
  setup(__props) {

const { tm } = useI18n();

const instructions = computed(
  () => tm("calculators.tarot.situation-prediction.instruction") as unknown
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(instructions.value.first_title), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(instructions.value.first_paragraph), 1),
    _createElementVNode("h6", _hoisted_4, _toDisplayString(instructions.value.second_title), 1),
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(instructions.value.list, (item, i) => {
        return (_openBlock(), _createElementBlock("li", { key: i }, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(item.bold), 1),
          _createTextVNode(" " + _toDisplayString(item.text), 1)
        ]))
      }), 128))
    ])
  ]))
}
}

})